import styled from 'styled-components';
import { Icon } from '@iconify/react';

type InputProps = {
  borderColor?: string | undefined;
  height?: string | undefined;
  borderRadius?: string | undefined;
}

export const InputWrapper = styled.div<InputProps>`
  background-color: ${props => props.theme.colors.card_300};
  border: 1px solid;
  border-color: ${({ borderColor }) => (borderColor ? borderColor : props => props.theme.colors.primary)};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '4px')};
  position: relative; 
  display: flex; 
  align-items: center; 
`;

export const Input = styled.input<InputProps>`
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '4px')};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0 15px;
  padding-right: 40px; 
  font-size: 13px;
  line-height: 1;
  height: ${({ height }) => (height ? height : '35px')};
  width: 100%;
  background-color: ${props => props.theme.colors.card_300};
  color: ${props => props.theme.colors.text};

  border: none;

  &:hover {
    background-color: ${props => props.theme.colors.hover};
  }

  &:focus {
    box-shadow: 0 0 0 2px black;
  }

  &::placeholder {
    color: ${props => props.theme.colors.grey_text};
  }

  &[data-placeholder] {
    color: ${props => props.theme.colors.primary};
  }
`;

export const InputIcon = styled(Icon)`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%); 
`;

export const HiddenInput = styled(Input)`
  display: none;
  visibility: hidden;
`;
